import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const uploadMemberRenewalBatch = (formData) =>
  axios.post(`${BASE_URL}/members/batch-renewal/upload`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });

export const getMemberRenewalBatchUploadHistory = (params) =>
  axios.get(`${BASE_URL}/members/batch-renewal/uploads`, {
    params,
    headers: getAuthHeaders(),
  });

export const getMemberRenewalBatchProcessedRows = (uploadId, params) =>
  axios.get(`${BASE_URL}/members/batch-renewal/processed/${uploadId}`, {
    params,
    headers: getAuthHeaders(),
  });

export const exportMemberRenewalBatchProcessedRows = (uploadId, params) =>
  axios.post(
    `${BASE_URL}/members/batch-renewal/processed-export/${uploadId}`,
    {},
    {
      params,
      headers: getAuthHeaders(),
      responseType: "blob",
    }
  );

export const refreshMemberRenewalBatchUploadSignedUrl = (uploadId) =>
  axios.post(
    `${BASE_URL}/members/batch-renewal/refresh-url`,
    { upload_id: uploadId },
    { headers: getAuthHeaders() }
  );
